import Vue from "vue";
import Router from "vue-router";
import AppHeader from "./layout/AppHeader";
import AppHeaderDark from "./layout/AppHeaderDark";
import AppFooter from "./layout/AppFooter";
import Components from "./views/Components.vue";
import Landing from "./views/Landing.vue";
import Login from "./views/Login.vue";
import Company from "./views/Company";
import Global from "./views/Global";
import Contact from "./views/Contact";
import Overview from "./views/solutions/Overview/Overview";
import ProductsLine from "./views/solutions/Overview/ProductsLine";
import ServicesStructure from "./views/solutions/Overview/ServicesStructure";
import Digitalinfrastructure from "./views/solutions/DigitalInfrastructure/Digitalinfra";
import DigitalNetworking from "./views/solutions/DigitalInfrastructure/Networking";
import DigitalCollaboration from "./views/solutions/DigitalInfrastructure/Collaboration";
import DigitalAnalytics from "./views/solutions/DigitalInfrastructure/Analytics";

import Digitalsecurity from "./views/solutions/Security/Digitalsecurity";
import Cloud from "./views/solutions/Cloud/Cloud";
import HybridCloud from "./views/solutions/Cloud/HybridCloud";
import DataCenterModernization from "./views/solutions/Cloud/DataCenterModernization";
import DevOps from "./views/solutions/Cloud/DevOps";

import LifeCycleManagement from "./views/services/LifeCycleManagement";
import IntegrationImplementation from "./views/services/IntegrationImplementation";
import RelocationServices from "./views/services/RelocationServices";
import AssetManagement from "./views/services/AssetManagement";
import ManagedServices from "./views/services/ManagedServices";

Vue.use(Router);

export default new Router({
  linkExactActiveClass: "active",
  mode: "history",
  routes: [
    {
      path: "/components",
      name: "components",
      components: {
        header: AppHeader,
        default: Components,
        footer: AppFooter,
      },
    },
    {
      path: "/contact",
      name: "contact",
      components: {
        header: AppHeaderDark,
        default: Contact,
        footer: AppFooter,
      },
    },
    {
      path: "/",
      name: "landing",
      components: {
        header: AppHeader,
        default: Landing,
        footer: AppFooter,
      },
    },
    {
      path: "/login",
      name: "login",
      components: {
        header: AppHeader,
        default: Login,
        footer: AppFooter,
      },
    },
    {
      path: "/company",
      name: "company",
      components: {
        header: AppHeaderDark,
        default: Company,
        footer: AppFooter,
      },
    },
    {
      path: "/global",
      name: "global",
      components: {
        header: AppHeaderDark,
        default: Global,
        footer: AppFooter,
      },
    },

    {
      path: "/solutions",
      name: "solutions",
      components: {
        header: AppHeaderDark,
        default: Overview,
        footer: AppFooter,
      },
    },
    {
      path: "/solutions/overview",
      name: "Overview",
      components: {
        header: AppHeaderDark,
        default: Overview,
        footer: AppFooter,
      },
    },
    {
      path: "/solutions/overview/productsline",
      name: "ProductsLine",
      components: {
        header: AppHeaderDark,
        default: ProductsLine,
        footer: AppFooter,
      },
    },
    {
      path: "/solutions/overview/servicesstructure",
      name: "Overview",
      components: {
        header: AppHeaderDark,
        default: ServicesStructure,
        footer: AppFooter,
      },
    },

    ,
    {
      path: "/solutions/digitalinfrastructure",
      name: "DigitalInfrastructure",
      components: {
        header: AppHeaderDark,
        default: Digitalinfrastructure,
        footer: AppFooter,
      },
    },
    {
      path: "/solutions/digitalinfrastructure/networking",
      name: "networking",
      components: {
        header: AppHeaderDark,
        default: DigitalNetworking,
        footer: AppFooter,
      },
    },
    {
      path: "/solutions/digitalinfrastructure/collaboration",
      name: "collaboration",
      components: {
        header: AppHeaderDark,
        default: DigitalCollaboration,
        footer: AppFooter,
      },
    },
    {
      path: "/solutions/digitalinfrastructure/analytics",
      name: "analytics",
      components: {
        header: AppHeaderDark,
        default: DigitalAnalytics,
        footer: AppFooter,
      },
    },

    {
      path: "/solutions/digitalsecurity",
      name: "Digitalsecurity",
      components: {
        header: AppHeaderDark,
        default: Digitalsecurity,
        footer: AppFooter,
      },
    },
    {
      path: "/solutions/cloud",
      name: "Cloud",
      components: {
        header: AppHeaderDark,
        default: Cloud,
        footer: AppFooter,
      },
    },
    {
      path: "/solutions/cloud/datacentermodernization",
      name: "datacenters",
      components: {
        header: AppHeaderDark,
        default: DataCenterModernization,
        footer: AppFooter,
      },
    },

    {
      path: "/solutions/cloud/devops",
      name: "devops",
      components: {
        header: AppHeaderDark,
        default: DevOps,
        footer: AppFooter,
      },
    },
    {
      path: "/solutions/cloud/hybridclouds",
      name: "hybridclouds",
      components: {
        header: AppHeaderDark,
        default: HybridCloud,
        footer: AppFooter,
      },
    },

    ,
    {
      path: "/services/assetmanagementandsupport",
      name: "assetmanagement",
      components: {
        header: AppHeaderDark,
        default: AssetManagement,
        footer: AppFooter,
      },
    },

    ,
    {
      path: "/services/integrationandimplementation",
      name: "integrationandimplementation",
      components: {
        header: AppHeaderDark,
        default: IntegrationImplementation,
        footer: AppFooter,
      },
    },

    ,
    {
      path: "/services/lifecyclemanagement",
      name: "lifecyclemanagement",
      components: {
        header: AppHeaderDark,
        default: LifeCycleManagement,
        footer: AppFooter,
      },
    },

    {
      path: "/services",
      name: "managedservices",
      components: {
        header: AppHeaderDark,
        default: ManagedServices,
        footer: AppFooter,
      },
    },
    ,
    {
      path: "/services/managedservices",
      name: "managedservices",
      components: {
        header: AppHeaderDark,
        default: ManagedServices,
        footer: AppFooter,
      },
    },
    ,
    {
      path: "/services/relocationservices",
      name: "Cloud",
      components: {
        header: AppHeaderDark,
        default: RelocationServices,
        footer: AppFooter,
      },
    },
  ],
  scrollBehavior: (to) => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  },
});
